var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_4583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.781396 16C0.626858 16 0.475783 15.9542 0.347281 15.8684C0.218778 15.7825 0.118621 15.6605 0.0594776 15.5177C0.000334661 15.3749 -0.0151369 15.2178 0.0150198 15.0663C0.0451766 14.9147 0.119607 14.7755 0.228896 14.6662L14.6664 0.228731C14.8129 0.0821988 15.0117 -0.00012207 15.2189 -0.00012207C15.4261 -0.00012207 15.6249 0.0821988 15.7714 0.228731C15.9179 0.375263 16.0002 0.574003 16.0002 0.781231C16.0002 0.988459 15.9179 1.1872 15.7714 1.33373L1.3339 15.7712C1.26141 15.8439 1.17528 15.9015 1.08047 15.9407C0.985653 15.98 0.884016 16.0001 0.781396 16Z",
    fill: "#4F4F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2189 16C15.1162 16.0001 15.0146 15.98 14.9198 15.9407C14.825 15.9015 14.7388 15.8439 14.6664 15.7712L0.228853 1.33373C0.0823209 1.1872 0 0.988459 0 0.781231C0 0.574003 0.0823209 0.375263 0.228853 0.228731C0.375385 0.0821988 0.574125 -0.00012207 0.781353 -0.00012207C0.988581 -0.00012207 1.18732 0.0821988 1.33385 0.228731L15.7714 14.6662C15.8806 14.7755 15.9551 14.9147 15.9852 15.0663C16.0154 15.2178 15.9999 15.3749 15.9408 15.5177C15.8816 15.6605 15.7815 15.7825 15.653 15.8684C15.5245 15.9542 15.3734 16 15.2189 16Z",
    fill: "#4F4F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_4583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.28f6f0df82f43bec53e64291cc2d08f4.svg";
export { ForwardRef as ReactComponent };